
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { CardValidation } from "@/store/rules-engine/types";

@Component({})
export default class RulesCheckbox extends Vue {
    @Prop({type: [Boolean, Object, null]})
    private value!: boolean | object | null;

	@Prop({type: String})
    private placeholderText!: string;

	@Prop({type: Boolean, default: true})
	private allowNulls!: boolean;

	@Prop({type: Boolean, default: false})
	private readOnly!: boolean;

	@Prop({type: String, default: ""})
	private toolTipText!: string;

	@Prop({type: String, default: ""})
	private propertyName!: string;

    private checkboxValue: boolean = null;
	private inputValidation: CardValidation = { isValid: false, message: ""};

    private mounted(): void {
		this.processValue()
    }

    private get inputValid(): boolean {
        return this.allowNulls || this.checkboxValue !== null;
    }

    @Watch("value")
    private processValue(): void {
        if (typeof this.value === 'object' && this.value !== null && this.propertyName) {
            // Extract boolean from object using propertyName
            this.checkboxValue = this.propertyName in this.value ? 
                Boolean(this.value[this.propertyName]) : null;
        } else {
            // Handle direct boolean value
            this.checkboxValue = this.value === null ? null : Boolean(this.value);
        }
        
        this.validateInput()
    }

    @Watch("checkboxValue")
    private onCheckboxValueChange(): void {
        this.validateInput();
        this.$emit("input", this.checkboxValue);
    }

    @Emit("isValid")
    private validateInput(): CardValidation {
        this.inputValidation = {
            isValid: this.inputValid,
            message: this.inputValid ? "" : "*Field must contain a valid value"
        };
        return this.inputValidation;
    }
}
